<template>
  <div class="section">
    <div class="container">
      <EventWizardGeneralCard
        v-if="$route.query.test == null"
        :organization-id="$route.params.organizationId"
        :event-id="$route.params.eventId"
      />
      <EventWizardLimitedCard
        v-else
        :organization-id="$route.params.organizationId"
        :event-id="$route.params.eventId"
      />
    </div>
  </div>
</template>

<script>
import EventWizardGeneralCard from "@/components/EventWizardGeneralCard.vue";
import EventWizardLimitedCard from "@/components/EventWizardLimitedCard.vue";

export default {
  name: "EventWizardLimited",
  components: {
    EventWizardGeneralCard,
    EventWizardLimitedCard,
  },
};
</script>
